
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/sleepwear",
      function () {
        return require("private-next-pages/apparel/sleepwear/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/sleepwear"])
      });
    }
  